module.exports = __webpack_public_path__ + "69e073b6d7877a6610d3e599540f20fc.png";